import script from "./QuestionnairePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnairePage.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=b4aa85dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4aa85dc"]])

export default __exports__